export type QuotedFlagState = {
  isQuoted?: boolean;
};

export function isSystemQuotedStatus(
  system: { uniqueId: string; quoteStatus?: string },
  quotedUniqueIds: ReadonlySet<string>,
  quotableSystems: Record<string, QuotedFlagState>
): boolean {
  if (system.quoteStatus === 'sent') return true;
  if (!quotedUniqueIds.has(system.uniqueId)) return false;
  return quotableSystems[system.uniqueId]?.isQuoted !== false;
}

export function shouldShowQuotedSnapshot(
  snapshotUniqueId: string | undefined,
  liveSystems: Array<{ uniqueId: string }>,
  isLiveQuoted: (system: { uniqueId: string }) => boolean
): boolean {
  if (!snapshotUniqueId) return true;
  const live = liveSystems.find(
    (system) => system.uniqueId === snapshotUniqueId
  );
  if (!live) return true;
  return isLiveQuoted(live);
}

export function missingQuotedSystems<
  T extends { uniqueId?: string },
  S extends { uniqueId?: string }
>(selectedSystems: T[], quotedSnapshots: S[]): S[] {
  const existingIds = new Set(
    selectedSystems
      .map((system) => system.uniqueId)
      .filter((id): id is string => Boolean(id))
  );
  return quotedSnapshots.filter((snapshot) => {
    if (!snapshot.uniqueId) return false;
    return !existingIds.has(snapshot.uniqueId);
  });
}
